<template>
  <div class="footer-wrapper">
    <footer class="fixed-bottom">
      &copy; {{new Date().getFullYear()}} Psytest AB
    </footer>
  </div>
</template>

<script>
export default {
  name: 'appfooter'
}
</script>

<style scoped>
footer {
  padding: 5px;
  text-align: center;
  color: #999;
  background: #fff;
}
.footer-wrapper {
  margin-top: 50px;
}
</style>
